import {useCallback, useState} from "react"

const read = (key, fallback) => {
    try {
        const raw = window.localStorage.getItem(key)
        const n = raw === null ? NaN : Number(raw)
        return Number.isFinite(n) ? n : fallback
    } catch (e) {
        return fallback
    }
}

/**
 * Numeric state persisted in localStorage (e.g. a panel width).
 * Returns [value, set].
 */
export default function useStoredNumber(key, fallback) {
    const [value, setValue] = useState(() => read(key, fallback))

    const set = useCallback((next) => {
        setValue(next)
        try {
            window.localStorage.setItem(key, String(next))
        } catch (e) {
            // storage unavailable — keep in-memory state only
        }
    }, [key])

    return [value, set]
}
